import React from 'react';
import Link from 'gatsby-link';

const BreadCrumbs = ({ ancestors, pathContext }) => {
  return (
    <div className="breadcrumbs">
      {ancestors.map(ancestor => {
        return <span className="crumb"><Link to={ancestor.node.path}>{ancestor.node.context.title}</Link></span>
      })}
      <span className="crumb">{pathContext.title}</span>
    </div>
  );
}
export default BreadCrumbs;


// WEBPACK FOOTER //
// ./src/components/BreadCrumbs/index.js